export enum NegotiationStatus {
  ALL = 'all',
  RUNNING = 'running',
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  CANCELLED_BY_USER = 'cancelled-by-user',
  CANCELLED_BY_SYSTEM = 'cancelled-by-system',
}
